import { render, staticRenderFns } from "./WeekPicker.vue?vue&type=template&id=8b4cbd5e"
import script from "./WeekPicker.vue?vue&type=script&lang=js"
export * from "./WeekPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports